import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import jQuery from "jquery";

import { SessionStorageService } from "ngx-webstorage/dist/services";
import { JwtHelper } from "angular2-jwt/angular2-jwt";
import { AdministracionContatosService } from "./administracion-contactos.service";
import { ClienteLogin, ClienteXCiudad, MenuXUsuario, Menu } from "../login/cliente_login";
import { SessionTokenService } from "../../components/common/utils/sessionToken.service";
import { HandleError } from "../../components/common/utils/handleError.component";

const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
    selector: 'administracionContactos',
    providers: [AdministracionContatosService],
    templateUrl: 'administracion-contactos.template.html'
})

export class AdministracionContactosComponent implements OnInit {
    usuario: ClienteLogin;
    usuarioEmpresa: ClienteXCiudad;
    menuXContacto: MenuXUsuario[];

    constructor(
        private administracionConctactosService: AdministracionContatosService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService
    ) { }

    ngOnInit() {
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                try {
                    this.usuarioEmpresa = JSON.parse(this.sesionStorageService.retrieve("usuarioEmpresa"));
                } catch (e) {
                    this.usuarioEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
                }
                this.cargaTodo();
                this.sesionStorageService.observe("usuarioEmpresa").subscribe(v => {
                    try {
                        this.usuarioEmpresa = JSON.parse(v);
                        this.cargaTodo();
                    } catch (e) {
                        this.usuarioEmpresa = v;
                        this.cargaTodo();
                    }
                });
            }
        }
    }

    cargaTodo() {
        this.administracionConctactosService.consultarConctactosClienteMenu(this.usuarioEmpresa).subscribe(
            result => {
                if (result.length > 0) {
                    result.forEach(a => {
                        a.Menus.forEach(b => {
                            if (b.Seleccionado == true) {
                                if (b.Hijos != null) {
                                    b.Hijos.forEach(c => {
                                        c.Habilitado = true;
                                        if (c.Seleccionado == true) {
                                            if (c.Hijos != null) {
                                                c.Hijos.forEach(d => {
                                                    d.Habilitado = true;
                                                    if (d.Seleccionado == true) {
                                                        if (d.Hijos != null) {
                                                            d.Hijos.forEach(e => {
                                                                e.Habilitado = true;
                                                            });
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                    });
                                }
                            }
                        });
                    });
                    this.menuXContacto = result;
                }else{
                    this.menuXContacto = null;
                }
            },
            error => {
                this.handleError.redirectUrl(error);
            });
    }

    selectAll(evento: any, menu: Menu, menuXUsuario: MenuXUsuario) {
        let bandera = true;
        if (menu.Seleccionado == true) {
            bandera = false;
        }
        if (menu.Hijos != null) {
            menu.Hijos.forEach(a => {
                a.Habilitado = bandera;
                a.Seleccionado = false;
                if (a.Hijos != null && bandera == false) {
                    a.Hijos.forEach(b => {
                        b.Habilitado = bandera;
                        b.Seleccionado = false;
                        if (b.Hijos != null) {
                            b.Hijos.forEach(c => {
                                c.Habilitado = bandera;
                                c.Seleccionado = false;
                            });
                        }
                    });
                }
            });
        }
    }

    guardarCambios() {
        this.administracionConctactosService.guardarCambiosUsuarios(this.menuXContacto)
            .subscribe(result => {
                if (result) {
                    swal({
                        title: 'Datos actualizados',
                        text: "Su información ha sido actualizada satisfactoriamente",
                        type: 'success'
                    });
                } else {
                    swal({
                        title: 'Datos actualizados',
                        text: "Ha ocurrido un error al intentar actualizar la información",
                        type: 'error'
                    });
                }
            },
            error => {
                this.handleError.redirectUrl(error);
            })
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/administracion-contactos/administracion-contactos.component.ts